import React, { Component } from 'react'
import '../../../CSS/dashboard.css'
import ReusableButton from '../../../SharedComponents/Button/Button'
import $ from "jquery"
import 'jquery-ui-dist/jquery-ui.min.css';
import { NavLink } from 'react-router-dom'
import Loading from '../../../Images/loading.gif'
import DashboardCleanersAdminHeader from '../../Shared/DashboardCleanersAdminHeader/DashboardCleanersAdminHeader'
import { destroySession } from '../../../Utility/Utility'
import DashboardCleanerLogo from '../../../SharedComponents/DashboardCleanerLogo/DashboardCleanerLogo'
import * as DashboardAdminHelpPageConstant from './DashboardAdminHelpPageConstant'
import { IoIosContact } from 'react-icons/io'
import { IconContext } from "react-icons";
import { Redirect } from 'react-router-dom'


class DashboardAdminHelpPageHeader extends Component {
    constructor(props) {
        super();
        this.state = {
            redirectLogin: false,
            roleName: '',
            Name : '',
            redirectError400: false,
            redirectError401: false,
            redirectError404: false,
            redirectError500: false,
            VendorName : "",
            roleID : ""
        }
        this.handleLogout = this.handleLogout.bind(this);

    }
    componentWillMount() {
        if(sessionStorage.getItem('token')) {
            var Role = sessionStorage.getItem('role')
            this.setState({
                roleID : Role
            })
            var VendorName = sessionStorage.getItem('vendorName')
            if(Role == "1") {
               let RoleName = VendorName +" "+"Admin"
             this.setState({
                 roleName :  RoleName,
                 VendorName : VendorName
             })
            }
            if(Role == "3" ) {
            let RoleName = "Super Admin"
                this.setState({
                 roleName :  RoleName,
                })
            }
            var Name = sessionStorage.getItem('name')
            this.setState({
                Name: Name
              
            })
        }
        else {
            this.setState({
                redirectLogin: true      
            })
        }
       
    }
    handleLogout() {
        destroySession();
        this.setState({
            redirectLogin: true
        })
    }

  
    render() {
        if (this.state.redirectLogin) {
            return (<Redirect to={'/DashboardLogin'} />)
        }
        if (this.state.redirectError400) {
            return (<Redirect to={'/CleanersDashboardError400'} />)
        }
        if (this.state.redirectError401) {
            return (<Redirect to={'/CleanersDashboardError401'} />)
        }
        if (this.state.redirectError404) {
            return (<Redirect to={'/CleanersDashboardError404'} />)
        }
        if (this.state.redirectError500) {
            return (<Redirect to={'/CleanersDashboardError500'} />)
        }
        return (
            <div>
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                 <div className="CoopHeaderDashboardAdmin" >
                    <div className="CoopHeaderAdmin">
                        <DashboardCleanerLogo />
                        {/* <CleanersDashboardHome {...this.state}/> */}
                        <p>{DashboardAdminHelpPageConstant.visit}</p>
                        <button className="button-header">{DashboardAdminHelpPageConstant.cleaning}</button>
                        {/* {this.state.roleName == "Super Admin"? */}
                        {/* <div className="headerMenuAdminTop">
                        <ul className="header-menuAdmin" >
                        <li>  <NavLink to="#" className="ConfigActive" >{DashboardAdminHelpPageConstant.Config}</NavLink> </li>
                        <li>  <NavLink to="/CleanersDashboardHome" className="ClenaersInactive" >{DashboardAdminHelpPageConstant.CleanersDashboard}</NavLink> </li>
                        </ul>
                        </div> */}
                         {/* : null
                          } */}
                             {this.state.roleID ==  "1" || this.state.roleID ==  "3" ?
                        <div className="headerMenuAdminTop">
                        <ul className="header-menuAdmin" >
                        <li>  <NavLink to="#" className="ConfigActive" >{DashboardAdminHelpPageConstant.Config}</NavLink> </li>
                        <li>  <NavLink to="/CleanersDashboardHome" className="ClenaersInactive" >{DashboardAdminHelpPageConstant.CleanersDashboard}</NavLink> </li>
                        </ul>
                        </div>
                         :  null
                          }
                                {this.state.roleID ==  "2" ?
                        <div className="headerMenuAdminTop">
                        <ul className="header-menuAdmin" >
                        <li>  <NavLink to="/CleanersDashboardHome" className="ClenaersInactive" >{DashboardAdminHelpPageConstant.CleanersDashboard}</NavLink> </li>
                        </ul>
                        </div>
                         :  null
                          }
                    </div>
                    <div className="coop-visitor">
                        <div className="coopIcon">
                            <div className="roleName">{this.state.roleName}</div>
                            <IconContext.Provider
                                value={{ color: 'white', className: "global-class-name.Dashboard" }}
                            >
                                <IoIosContact size={30} />
                            </IconContext.Provider>
                            <ReusableButton buttonText={this.state.Name} className="RoleName"></ReusableButton>
                            <p  className="HelpPage">{DashboardAdminHelpPageConstant.Help}</p>
                            <p onClick={this.handleLogout} className="Logout">{DashboardAdminHelpPageConstant.Logout}</p>
                        </div>
                    </div>
                </div>
                <div className="NavLinks">
                    <div className="DashboardMenuAdmin">
                        <div className="menuAdmin" >
                            <div className="headerMenuAdmin">
                                <ul className="header-menuAdminHelpPage" >
                                    <li> <NavLink to="/CleanersDashboardHelpGuide" >{DashboardAdminHelpPageConstant.DashboardGuide}</NavLink></li>
                                    {this.state.roleID ==  "1" || this.state.roleID ==  "3" ?
                                    <li> <NavLink to="/CleanersDashboardConfigPanelHelpGuide">{DashboardAdminHelpPageConstant.ConfigPanelGuide}</NavLink></li> : null }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }



}
export default DashboardAdminHelpPageHeader;